import dayjs, { Dayjs } from 'dayjs';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';

import DateRangePicker, {
  DateRangePickerDateSelectFunction,
} from '~components/Filters/DateRangePicker';

import FilesQueryContext from '../../FilesQueryContext';

const deriveDateRangeFromFilesQueryFilters = (
  startDate: Dayjs | undefined,
  endDate: Dayjs | undefined,
) => {
  const start = startDate ? dayjs.tz(startDate) : null;
  const end = endDate ? dayjs.tz(endDate) : null;

  return [start, end];
};

export default function DateRangeFilter() {
  const filesQuery = useContext(FilesQueryContext);

  const initialDateRate = useMemo(() => {
    return deriveDateRangeFromFilesQueryFilters(
      filesQuery.filters.startDate,
      filesQuery.filters.endDate,
    );
  }, [filesQuery.filters.startDate, filesQuery.filters.endDate]);

  const [selecteDateRange, setSelectedDateRange] = useState([...initialDateRate]);

  const handleDateSelect = useCallback<DateRangePickerDateSelectFunction>(
    (startDate, endDate) => {
      setSelectedDateRange([startDate, endDate ?? startDate]);
    },
    [],
  );

  const handleAnchorClose = useCallback(() => {
    const startDate = selecteDateRange[0] ?? undefined;
    const endDate = selecteDateRange[1] ?? undefined;

    const startDateDidChange =
      filesQuery.filters.startDate?.toString() !== startDate?.toString();
    const endDateDidChange =
      filesQuery.filters.endDate?.toString() !== endDate?.toString();

    if (startDateDidChange || endDateDidChange) {
      filesQuery.applyFilters({ startDate, endDate });
    }
  }, [
    selecteDateRange[0],
    selecteDateRange[1],
    filesQuery.filters.startDate,
    filesQuery.filters.endDate,
  ]);

  useEffect(() => {
    const dateRange = deriveDateRangeFromFilesQueryFilters(
      filesQuery.filters.startDate,
      filesQuery.filters.endDate,
    );

    setSelectedDateRange(dateRange);
  }, [filesQuery.filters.startDate, filesQuery.filters.endDate]);

  return (
    <DateRangePicker
      allowAllDates
      endDate={selecteDateRange[1]}
      mode="icon"
      onAnchorClose={handleAnchorClose}
      onDateSelect={handleDateSelect}
      showShortcuts
      startDate={selecteDateRange[0]}
      useTodayFormat
    />
  );
}
